/**
 * Gate anti-boucle — chargement fiche membre Mon Équipe (LOT1).
 * Empêche de rappeler getEquipeMember tant que (selectedId, commercantId) n'a pas changé.
 */
export function createMemberDetailLoadGate() {
  let lastKey = null;

  return {
    key(selectedId, commercantId) {
      if (!selectedId) return null;
      return `${commercantId || ''}::${selectedId}`;
    },
    shouldLoad(selectedId, commercantId) {
      const next = this.key(selectedId, commercantId);
      if (!next) return false;
      return lastKey !== next;
    },
    markLoaded(selectedId, commercantId) {
      lastKey = this.key(selectedId, commercantId);
    },
    reset() {
      lastKey = null;
    },
    getLastKey() {
      return lastKey;
    },
  };
}

/** true si le query param member doit être mis à jour. */
export function shouldUpdateMemberSearchParam(currentMemberParam, selectedId) {
  if (!selectedId) return false;
  return currentMemberParam !== selectedId;
}
